import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { UnpaidDetailsWithEndpoints } from 'cpes-common';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<
    UnpaidDetailsWithEndpoints,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'unpaidDetails',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then(response => response.data);
    },
});

export default reducer;
export const fetchUnpaidDetails = fetchData;
